<template>
	<div class="user-dropdown" @focus="show" @focusout="hide" :class="{ open }" tabindex="-1">
		{{ user.name }}
		<font-awesome-icon icon="caret-down" class="user-dropdown-icon" />
		<ul class="user-dropdown-options" v-if="open">
			<slot></slot>
		</ul>
	</div>
</template>

<script>
export default {
	data () {
		return {
			open: false
		};
	},

	methods: {
		/**
		 * Shows the dropdown menu.
		 *
		 * @returns {void}
		 */
		show () {
			this.open = true;
		},

		/**
		 * Hides the dropdown menu.
		 *
		 * @returns {void}
		 */
		hide () {
			this.open = false;
		}
	},

	computed: {
		/**
		 * Returns the `currentUser` property from the store.
		 *
		 * @returns {object}
		 */
		user () {
			return this.$store.getters['auth/currentUser'];
		}
	}
};
</script>

<style lang="scss">
@import '../../variables';
@import '../../mixins';

.user-dropdown {
	position: absolute;
	top: 0;
	right: 0;
	padding-left: 15px;
	padding-right: 15px;
	height: $app-topbar-height;
	line-height: $app-topbar-height;
	color: $app-topbar-color;
	font-size: 13px;
	cursor: pointer;

	&:hover {
		background-color: rgba(white, 0.1);
	}

	&:focus {
		outline: none;
	}

	&.open {
		background-color: rgba(white, 0.25);
	}

	.user-dropdown-icon {
		margin-left: 5px;
	}

	.user-dropdown-options {
		position: absolute;
		top: $app-topbar-height;
		right: 0;
		min-width: 100%;
		list-style-type: none;
		margin: 0;
		padding: 0;
		background-color: white;
		@include card(2);
	}
}
</style>
